module.exports = __webpack_public_path__ + "img/Macao.55225faf.svg";